'use client';

import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { branchesListId } from '@/app/(main)/(pages)/_components/branches-section/consts/branches-section.const';
import { Button } from '@/components/ui/button/button.component';
import { ButtonProps } from '@/components/ui/button/button.types';
import { cn } from '@/utils/cn-tw-merge';
import { branchDefaultWhatsappMessage } from '@/utils/consts/cta-whatsapp-messages.consts';
import { Link } from '@/components/ui/link/link.component';
import { useWhatsappLinkSimple } from '@/hooks/use-whatsapp/use-whatsapp-link-simple.hook';

interface BranchScheduleButtonProps extends ButtonProps {
  title?: string;
  branchesLength: number;
  whatsapp?: string;
  isAfterBranchesSection?: boolean;
}

export const BranchScheduleButton = ({
  title = 'Agendar com atendente',
  branchesLength,
  whatsapp = '',
  className,
  variant = 'secondary',
  color,
  isAfterBranchesSection = false,
  ...props
}: BranchScheduleButtonProps) => {
  const { resolveLink } = useWhatsappLinkSimple(whatsapp, branchDefaultWhatsappMessage);
  const hasOneBranchInCity = branchesLength === 1;
  const hasMoreThanOneBranch = branchesLength > 1;
  const buttonIcon = hasOneBranchInCity
    ? faWhatsapp
    : isAfterBranchesSection ? faChevronUp : faChevronDown;
  const whatsappLink = resolveLink(whatsapp);

  const handleClickButton = (): void => {
    if (hasMoreThanOneBranch) {
      const section = document.getElementById(branchesListId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  return (
    <>
      { hasOneBranchInCity && whatsapp
        ? (
            <Link prefetch={false} target="_blank" href={whatsappLink} className="w-full">
              <Button
                data-testid={DataTestIdEnum.CITY_BRANCH_SCHEDULE_BUTTON}
                variant={variant}
                color={color}
                startIcon={buttonIcon}
                className={cn('h-12', className)}
                {...props}
              >
                {title}
              </Button>
            </Link>
          )
        : hasMoreThanOneBranch
          ? (
              <Button
                data-testid={DataTestIdEnum.CITY_BRANCH_SCHEDULE_BUTTON}
                variant={variant}
                color={color}
                startIcon={buttonIcon}
                className={cn('h-12', className)}
                onClick={handleClickButton}
                {...props}
              >
                {title}
              </Button>
            )
          : (
              null
            )}
    </>
  );
};
